let dom;

export const init = () => {
    initDom();
    navbarFocus();
    showDropdownMenu();
    showDropMenuMobile(
    );
    mobileMenuHandler();
}

const initDom = () => {
    dom = {
        nav: document.querySelector('#navbar .nav-lg'),
        navLinks: document.querySelectorAll('.nav__main .nav__list .nav-item__link'),
        dropDownNav: document.querySelector('.nav .dropdown-nav'),
        inputWrappers: document.querySelectorAll('.nav__sub .searchbar .input-wrapper'),
        mobileNavItems: document.querySelectorAll('.nav__main.nav-sm .collapse-menu .nav-item.dropdown'),
    };
};

const navbarFocus = () => {
    for (const inputWrapper of dom.inputWrappers) {
        inputWrapper.addEventListener('click', (event) => {
            inputWrapper.focus();
            if (!inputWrapper.classList.contains('focus')) {
                inputWrapper.classList.add('focus');
            }
        });

        inputWrapper.addEventListener('focusout', (event) => {
            inputWrapper.classList.remove('focus');
        });
    }
}

const showDropdownMenu = () => {
    for (const link of dom.navLinks) {
        link.addEventListener('mouseover', (event) => {
            const activeNav = link.dataset.nav;
            const dropDownNavItem = dom.dropDownNav.querySelector(`.dropdown-nav__item[data-nav="${activeNav}"]`);

            if (dropDownNavItem) {
                removeShowFromDropDownNavItem();

                dom.dropDownNav.classList.add('show');
                dropDownNavItem.classList.add('show');
            } else {
                dom.dropDownNav.classList.remove('show');
            }
        });

        dom.nav.addEventListener('mouseleave', (event) => {
            dom.dropDownNav.classList.remove('show');

            removeShowFromDropDownNavItem();
        });
    }
}

const removeShowFromDropDownNavItem = () => {
    const dropDownNavItems = dom.dropDownNav.querySelectorAll(`.dropdown-nav__item`);
    for (const navItem of dropDownNavItems) {
        navItem.classList.remove('show');
    }
}

const mobileMenuHandler = () => {
    const mobileNav = document.querySelector('.nav__main.nav-sm');
    if (mobileNav) {
        const menuToggler = mobileNav.querySelector('.menu-toggler');

        menuToggler.addEventListener('click', (event) => {
            mobileNav.classList.toggle('open');
            document.body.classList.toggle('overflow');
        })
    }
}

const showDropMenuMobile = () => {
    for (const navItem of dom.mobileNavItems) {
        navItem.addEventListener('click', (event) => {
            if (event.currentTarget.classList.contains('active')) {
                navItem.classList.toggle('active');
            } else {
                const activeDropDown = document.querySelector('.collapse-menu .nav-item.dropdown.active');
                if (activeDropDown) {
                    activeDropDown.classList.remove('active');
                }

                navItem.classList.toggle('active');
            }
        });
    }
}
